// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"navigation_Navigation__uZVa4"};